/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import * as React from 'react';
import * as PropTypes from 'prop-types';
import {compose} from "redux";
import {connect} from "react-redux";
import {TagType} from "../../../../data/aem.model";
import {FilterType, SidepanelCheckboxes} from "../../../../data/finders.model";
import Block from "../../../atoms/layout/Block";
import {Title} from "../../../atoms/text/Title";
import SelectedTags from "../../../molecules/finder/SelectedTags";
import {Button} from "../../../atoms/bootstrap/Button";
import {Glyphicons, Icon} from "../../../atoms/bootstrap/Icons";
import {openFinderPanel} from "../../../../actions/finder";
import {ShowHide} from "../../../atoms/layout/ShowHide";
import {getTagFilter} from "../../../../selectors/finder";
import {makeTagsMapper} from "../../../../selectors/tags";
import "../../../../utils/search-utils";
import {withI18N} from "../../../hoc/withI18N";
import {InformationIcon} from "../../../molecules/finder/InformationIcon";


class _SidepanelFilter extends React.Component {

    static propTypes = {
        filter: PropTypes.oneOfType([PropTypes.shape(SidepanelCheckboxes), PropTypes.any]),
        selected: PropTypes.arrayOf(PropTypes.shape(TagType)),
        expanded: PropTypes.bool,
        toggleTag: PropTypes.func,
        openFinderPanel: PropTypes.func
    };

    render() {
        const {filter, tags, groups = [], availableTags, toggleTag, selected, expanded, openFinderPanel, translate} = this.props;

        if (!filter || !filter.filterGroups || filter.filterGroups.length === 0 || availableTags.findIndex(availableTags => tags.findIndex(tag => tag?.id === availableTags) > -1) === -1) {
            return null;
        }

        return (<Block className={`finder__filter filter-${filter.type.toLowerCase()} ${expanded ? 'expanded' : ''}`}>
            <Block className="finder__filter-header">
                {filter.title && <Block className="p-flex p-justify-space-between">
                    <span className={"text-small-semi-bold"}>{filter.title}</span>
                    {filter.informationIcon && <InformationIcon message={filter.informationIcon} type="INFO"/>}
                </Block>}
            </Block>
            <Block className="finder__filter-body">
                <ShowHide show={!expanded && filter.subtitle}>
                    <div className={"btn-tertiary filter-sidepanel_checkboxes-button"} onClick={() => openFinderPanel(filter.index)}>
                        {filter.subtitle}
                    </div>
                </ShowHide>
                <ShowHide show={expanded}>
                    <div className="text-description">{filter.subtitle}</div>
                </ShowHide>
                <ShowHide show={selected?.length > 0}>
                    <Block className={"tag-list__selected-tags"}>
                        <SelectedTags key="selected-tags" selected={[].concat(selected, groups)}
                                      onTagSelect={toggleTag}/>
                    </Block>
                </ShowHide>
            </Block>
        </Block>)
    }
}

const mapStateToProps = () => {
    const tagMapper = makeTagsMapper((state, ownProps) => Object.keys(getTagFilter(state, ownProps.filter.index)));
    const selectedParents = makeTagsMapper((state, ownProps) => (ownProps.selected || [])
        .filter(selected => selected.id.lastIndexOf("/") !== -1)
        .map(selected => selected.id.substr(0, selected.id.lastIndexOf("/")))
        .uniqueValues());

    return (state, ownProps) => ({
        tags: tagMapper(state, ownProps),
        groups : selectedParents(state, ownProps)
    });
};

const mapActionsToProps = {
    openFinderPanel
};

export const SidepanelCheckboxesFilter = compose(connect(mapStateToProps, mapActionsToProps), withI18N)(_SidepanelFilter);
